/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceStepItem
 */
export interface SurfaceStepItem {
    /**
     * 
     * @type {string}
     * @memberof SurfaceStepItem
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStepItem
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStepItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStepItem
     */
    iconType?: SurfaceStepItemIconTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStepItem
     */
    iconName?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStepItem
     */
    imageId?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStepItem
     */
    imageUrl?: string;
    /**
     * Optional value label (e.g. "+200 PTS") — renders as right-aligned badge
     * @type {string}
     * @memberof SurfaceStepItem
     */
    value?: string;
}


/**
 * @export
 */
export const SurfaceStepItemIconTypeEnum = {
    number: 'number',
    icon: 'icon',
    image: 'image'
} as const;
export type SurfaceStepItemIconTypeEnum = typeof SurfaceStepItemIconTypeEnum[keyof typeof SurfaceStepItemIconTypeEnum];


/**
 * Check if a given object implements the SurfaceStepItem interface.
 */
export function instanceOfSurfaceStepItem(value: object): value is SurfaceStepItem {
    return true;
}

export function SurfaceStepItemFromJSON(json: any): SurfaceStepItem {
    return SurfaceStepItemFromJSONTyped(json, false);
}

export function SurfaceStepItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceStepItem {
    if (json == null) {
        return json;
    }
    return {
        
        '_id': json['_id'] == null ? undefined : json['_id'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'iconType': json['iconType'] == null ? undefined : json['iconType'],
        'iconName': json['iconName'] == null ? undefined : json['iconName'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function SurfaceStepItemToJSON(json: any): SurfaceStepItem {
    return SurfaceStepItemToJSONTyped(json, false);
}

export function SurfaceStepItemToJSONTyped(value?: SurfaceStepItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '_id': value['_id'],
        'title': value['title'],
        'description': value['description'],
        'iconType': value['iconType'],
        'iconName': value['iconName'],
        'imageId': value['imageId'],
        'imageUrl': value['imageUrl'],
        'value': value['value'],
    };
}

